export default __webpack_public_path__ + "static/media/2.4f079860.jpg";